// extracted by mini-css-extract-plugin
export default {"features":"style_features__HiSFm","featuresContent":"style_featuresContent__q3Quv","imageList":"style_imageList__lxpTm"};